// Source namespaces prevent unrelated remote/local records with equal raw IDs
// from collapsing. Explicit links give legacy events and bookings shared aliases.
export const venueEventKeys = (event) => {
  const keys = [];
  const linked = event.linkedVenueBooking?._id || event.linkedVenueBooking;
  if (event.bookingId || linked) keys.push(`venue:${event.bookingId || linked}`);
  if (event.unifiedId) keys.push(String(event.unifiedId));
  const id = event.sourceId || event._id || event.id;
  if (id) {
    const source = event.sourceType;
    const prefix = source === 'student-calendar' ? 'student'
      : source === 'institute-calendar' ? 'institute'
      : source === 'direct-venue-booking' || source === 'assistant-enquiry-booking' ? 'venue'
      : event.unifiedId?.split(':')[0] || (source === 'venue-booking' ? 'venue' : 'event');
    keys.push(`${prefix}:${id}`);
  }
  return [...new Set(keys)];
};

export const mergeVenueEvents = (...datasets) => {
  const groups = new Map();
  const aliases = new Map();
  for (const event of datasets.flat()) {
    if (!event || (event.recordType && event.recordType !== 'event')) continue;
    const keys = venueEventKeys(event);
    // Records without any stable identifier cannot be safely merged.
    if (!keys.length) continue;
    const matches = [...new Set(keys.map(key => aliases.get(key)).filter(Boolean))];
    const group = matches[0] || { event, keys: new Set() };
    for (const other of matches.slice(1)) {
      for (const key of other.keys) group.keys.add(key);
      groups.delete(other);
    }
    // A separately fetched practice record wins over a stale master snapshot.
    if (event.eventSessionType === 'practice_session') group.event = event;
    for (const key of keys) group.keys.add(key);
    for (const key of group.keys) aliases.set(key, group);
    groups.set(group, group.event);
  }
  return [...groups.values()];
};
